
import { Injectable, Inject } from '@angular/core';
import{BasePolicyClientDO} from './basePolicyClient.model';


export class GroupPolicyClientDO extends BasePolicyClientDO  {
    
     public  id:number = null;

}